module.exports = __webpack_public_path__ + "static/media/company.5ae0e704.svg";